import { useRewardLogic } from '@/hooks/useRewardLogic';
import { RewardForm } from '@/components/company/reward/RewardForm';
import { RewardFilters } from '@/components/company/reward/RewardFilters';
import { rewardColumns } from '@/components/company/reward/rewardColumns';
import CompanyHeader from '@/components/company/CompanyHeader';
import MainTable from '@/components/company/table/MainTable';

export default function Reward() {
  const {
    isLoading,
    allPublished,
    filteredRewards,
    formControl,
    formMode,
    formRef,
    fields,
    handleSave,
    handleDelete,
    onEdit,
    reset,
    pageConfig,
    setPageConfig,
    bulkPublishRewardHandler,
    searchTerm,
    setSearchTerm,
    selectedRole,
    setSelectedRole,
    selectedStatus,
    setSelectedStatus,
    clearFilters,
    orgCharts,
    setFormMode,
    roleOptions,
  } = useRewardLogic();

  return (
    <section className="w-full">
      <CompanyHeader
        title="Reward Systems"
        description="Manage your company's reward system and recognition programs."
        onCreate={() => {
          reset({ name: '', value: '', description: '' });
          setFormMode('add');
        }}
        onPublish={bulkPublishRewardHandler}
        isPublished={allPublished}
      />

      <div className="mx-5 border-b border-gray-200" />

      {formMode && orgCharts.length > 0 && (
        <RewardForm
          formControl={formControl}
          formRef={formRef}
          fields={fields}
          formMode={formMode}
          handleSave={handleSave}
          reset={reset}
          setFormMode={setFormMode}
        />
      )}

      <RewardFilters
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        selectedRole={selectedRole}
        setSelectedRole={setSelectedRole}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        clearFilters={clearFilters}
        roleOptions={roleOptions}
      />

      <MainTable
        showHeader={false}
        isLoading={isLoading}
        data={{
          content: filteredRewards as any[],
          totalElements: filteredRewards.length,
          totalPages: 1,
        }}
        columns={rewardColumns}
        pageConfig={pageConfig}
        setPageConfig={setPageConfig}
        onEdit={onEdit}
        onDelete={handleDelete}
        showActions
        useConfirmDelete
      />
    </section>
  );
}
